import { TOnboardingData } from '../types/onboarding';
import { createStaticReducer } from '../utils/redux/createStaticReducer';

export const onboardingReducer = createStaticReducer<TOnboardingData | null>(null);
